// assets
import {
  IconChartArea,
  IconMessage,
  IconPictureInPicture,
  IconChartDots,
  IconCertificate,
  IconChartBar,
  IconDeviceLaptop,
  IconTicket,
  IconServer,
  IconWorldSearch,
  IconUserEdit,
  IconReload,
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconChartPie,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconLayoutGrid,
  IconDevicesPlus,
  IconBoxModel,
  IconBuildingStore,
  IconTag,
  IconSettingsBolt,
  IconDeviceAudioTape,
  IconTemplate,
  IconBuilding,
  IconLockSquareRounded,
  IconLibrary,
  IconList,
  IconCircuitResistor,
  IconAlarm,
  IconThermometer,
  IconFile3d,
  IconBrandLoom,
  IconBrandAsana,
  IconReceiptYen,
  IconBellRinging,
  IconMessageExclamation,
  IconShieldLock,
  IconCoinYen,
  IconRegistered,
  IconHelp,
  IconUsers,
  IconClipboardData,
  IconFileDescription,
  IconBrandMyOppo
} from '@tabler/icons-react';
import { filterMenu } from 'layout/utils';
import { getUserInfo, isShowFinetuneMenu } from 'utils/common';

// constant
const icons = {
  IconDashboard,
  IconLayoutGrid,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconDevicesPlus,
  IconChartArea,
  IconTemplate,
  IconHelp
};

const getPanel = () => {
  const roleList = getUserInfo()?.roleInfo;
  const permissions = Array.isArray(roleList?.permissions) ? roleList.permissions.map((e) => e.name) : [];
  const panel = {
    id: 'panel',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: '用户总览',
        type: 'item',
        url: '/panel/dashboard/index',
        icon: icons.IconDashboard,
        breadcrumbs: false,
        isAdmin: false,
        group: '',
        key: 'UserOverview'
      },

      {
        id: 'exploration_center',
        title: '体验中心',
        type: 'collapse',
        icon: IconDeviceLaptop,
        breadcrumbs: false,
        isAdmin: false,
        group: '模型',
        children: [
          {
            id: 'chat_bot',
            title: '对话聊天',
            type: 'item',
            url: '/panel/exploration_center/index',
            icon: IconMessage,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ExperienceCenter-Chat'
          },
          {
            id: 'text2image',
            title: '文生图',
            type: 'item',
            url: '/panel/exploration_center/text2img/index',
            icon: IconPictureInPicture,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ExperienceCenter-TextGeneratedImage'
          },
          {
            id: 'text2language',
            title: '文生语音',
            type: 'item',
            url: '/panel/exploration_center/text2voice/index',
            icon: IconDeviceAudioTape,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ExperienceCenter-TextGeneratedVoice'
          }
        ]
      },
      {
        id: 'modelsquare',
        title: '模型广场',
        type: 'item',
        url: '/panel/modelsquare/index',
        icon: icons.IconLayoutGrid,
        breadcrumbs: false,
        isAdmin: false,
        group: '模型',
        key: 'ModelSquare'
      },
      {
        id: 'usage/index',
        title: '用量统计',
        type: 'item',
        url: '/panel/usage/index',
        icon: IconChartBar,
        breadcrumbs: false,
        isAdmin: false,
        group: '模型',
        key: 'DosageStatistics'
      },
      {
        id: 'token',
        title: '令牌管理',
        type: 'item',
        url: '/panel/token/index',
        icon: icons.IconKey,
        breadcrumbs: false,
        group: '模型',
        key: 'TokenManagement'
      },
      {
        id: 'videoTaskLog',
        title: '视频任务',
        type: 'item',
        url: '/panel/video-task-log/index',
        icon: IconClipboardData,
        breadcrumbs: false,
        isAdmin: false,
        group: '模型',
        key: 'VideoTaskLog'
      },

      // Dify 已下线：智能体 / 知识库入口关闭
      // {
      //   id: 'agent',
      //   title: '智能体',
      //   type: 'item',
      //   url: 'agent/index',
      //   icon: icons.IconRobot,
      //   breadcrumbs: false,
      //   isAdmin: false,
      //   group: '智能实验室',
      //   key: 'Agent'
      // },
      // {
      //   id: 'datasets',
      //   title: '知识库',
      //   type: 'item',
      //   url: 'datasets/index',
      //   icon: icons.IconDatabaseLeak,
      //   breadcrumbs: false,
      //   isAdmin: false,
      //   group: '智能实验室',
      //   key: 'KnowledgeBase'
      // },
      {
        id: 'cuewordproject',
        title: '提示词优化',
        type: 'item',
        url: 'cueWordproject/index',
        icon: icons.IconTemplate,
        breadcrumbs: false,
        isAdmin: false,
        group: '智能',
        key: 'PromptWordOptimization'
      },
      {
        id: 'model-adjustment',
        title: '模型微调',
        type: 'item',
        url: '/panel/model/fine_tuning_pro',
        icon: IconSettingsBolt,
        breadcrumbs: false,
        isAdmin: false,
        disabled: false,
        group: '训练',
        key: 'ModelFineTuning'
      },
      {
        id: 'model-deploy',
        title: '模型服务',
        type: 'item',
        url: '/panel/model/fine_service',
        icon: IconServer,
        breadcrumbs: false,
        disabled: false,
        isAdmin: false,
        group: '训练',
        key: 'ModelService'
      },
      {
        id: 'data-reflux/index',
        title: '数据回流',
        type: 'item',
        url: '/panel/data-reflux/index',
        icon: IconReload,
        breadcrumbs: false,
        isAdmin: false,
        group: '数据',
        key: 'DataReflux'
      },
      {
        id: 'enterprise/information',
        title: '我的企业',
        type: 'item',
        url: '/panel/my/enterprise/information/index',
        icon: IconBuilding,
        breadcrumbs: false,
        group: '',
        key: 'EnterprisePlatformTokenentErpriseInformation'
      },
      {
        id: 'vpn/private/line/index',
        title: '用量统计',
        type: 'item',
        url: '/panel/vpn/private/line/index',
        icon: IconChartPie,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformVPNPrivateLine'
      },
      {
        id: 'profile/online/topup/index',
        title: '在线充值',
        type: 'item',
        url: '/panel/profile/online/topup/index',
        icon: IconCoinYen,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformOnlineTopup'
      },
      {
        id: 'profile/topup/index',
        title: 'MaaS VPN 购买',
        type: 'item',
        url: '/panel/profile/topup/index',
        icon: IconBuildingStore,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformTopup'
      },
      {
        id: 'enterprise/token',
        title: 'MaaS VPN 配置',
        type: 'item',
        url: '/panel/enterprise/token/index',
        icon: icons.IconKey,
        breadcrumbs: false,
        group: '',
        key: 'EnterprisePlatformToken'
      },
      // {
      //   id: 'profile/order/manage/index',
      //   title: '账单明细',
      //   type: 'item',
      //   url: '/panel/profile/order/manage/index',
      //   icon: IconFileDescription,
      //   breadcrumbs: false,
      //   isAdmin: true,
      //   isRoot: true,
      //   group: '',
      //   key: 'EnterprisePlatformOrderManage'
      // },
      {
        id: 'profile/consume/index',
        title: 'Token账单',
        type: 'item',
        url: '/panel/profile/consume/index',
        icon: IconClipboardData,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformOrderConsume'
      },
      {
        id: 'profile/team_manage',
        title: '我的团队',
        type: 'item',
        url: '/panel/profile/team_manage',
        icon: IconUsers,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformTeam'
      },
      {
        id: 'profile/index',
        title: '账户设置',
        type: 'item',
        url: '/panel/profile/index',
        icon: IconUser,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '',
        key: 'EnterprisePlatformProfile'
      },
      {
        id: 'team_manage',
        title: '我的团队',
        type: 'item',
        url: '/panel/team_manage/index',
        icon: IconUsers,
        breadcrumbs: false,
        isAdmin: false,

        key: 'MyTeam'
      },
      // {
      //   id: 'helper_center',
      //   title: '帮助中心',
      //   type: 'item',
      //   url: '/panel/text-doc',
      //   icon: IconHelp,
      //   breadcrumbs: false,
      //   isAdmin: false,
      //   key: 'HelperCenter'
      // },
      {
        id: 'contact-us',
        title: '联系我们',
        type: 'item',
        url: '/panel/contact-doc',
        icon: IconFileDescription,
        breadcrumbs: false,
        isAdmin: false,
        key: 'ContactUs'
      },
      {
        id: 'large-screen-model',
        title: '大屏中心',
        type: 'collapse',
        icon: IconBrandLoom,
        breadcrumbs: false,
        isAdmin: false,
        group: '运维',
        children: [
          {
            id: 'large-screen-list/index',
            title: '大屏列表',
            type: 'item',
            url: '/panel/large-screen/list/index',
            icon: IconList,
            breadcrumbs: false,
            isAdmin: false,
            key: 'LargeScreenList'
          },
          {
            id: 'large-screen-model/index',
            title: '数据管理',
            type: 'item',
            url: '/panel/large-screen/model/index',
            icon: IconLibrary,
            breadcrumbs: false,
            isAdmin: false,
            key: 'LargeScreenModel'
          }
        ]
      },
      {
        id: 'modelCenter',
        title: '模型中心',
        type: 'collapse',
        icon: IconFile3d,
        breadcrumbs: false,
        isAdmin: false,
        group: '运维',
        children: [
          {
            id: 'modelChannel',
            title: '模型端点',
            type: 'item',
            url: '/panel/channel/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'TerminalPoint'
          },
          // {
          //   id: 'maasVpnChannel',
          //   title: 'MAAS VPN 端点',
          //   type: 'item',
          //   url: '/panel/maas/vpn/channel/index',
          //   icon: icons.IconSitemap,
          //   breadcrumbs: false,
          //   isAdmin: false,
          //   key: 'MaasVpnChannel'
          // },
          {
            id: 'modelSpeedLimit',
            title: '模型限速',
            type: 'item',
            url: '/panel/model-speed-limit/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ModelSpeedLimit'
          }
        ]
      },
      {
        id: 'teamCenter',
        title: '团队中心',
        type: 'collapse',
        icon: IconBrandAsana,
        breadcrumbs: false,
        isAdmin: false,
        group: '运维',
        children: [
          {
            id: 'teamList',
            title: '团队列表',
            type: 'item',
            url: '/panel/team-list/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'TeamList'
          }
        ]
      },
      {
        id: 'billingCenter',
        title: '账单中心',
        type: 'collapse',
        icon: IconReceiptYen,
        breadcrumbs: false,
        isAdmin: false,
        group: '运维',
        children: [
          {
            id: 'rechargeExchangeRecords',
            title: '充值兑换记录',
            type: 'item',
            url: '/panel/recharge_exchange_records/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'RechargeExchangeRecords'
          }
        ]
      },
      {
        id: 'log',
        title: '模型日志',
        type: 'item',
        url: '/panel/log/index',
        icon: icons.IconArticle,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        key: 'Logs'
      },
      {
        id: 'statistics',
        title: '数据统计',
        type: 'item',
        url: '/panel/statistics/index',
        icon: IconChartDots,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        key: 'DataStatistics'
      },
      {
        id: 'alarm',
        title: '告警中心',
        type: 'item',
        url: '/panel/alarm/index',
        icon: IconBellRinging,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        key: 'Alarm'
      },
      {
        id: 'announcements-center',
        title: '公告中心',
        type: 'collapse',
        url: '/panel/announcements/center',
        icon: IconMessageExclamation,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        children: [
          {
            id: 'announcements-dynamic',
            title: '动态公告',
            type: 'item',
            url: '/panel/announcements/center/dynamic/index',
            icon: IconAlarm,
            breadcrumbs: false,
            isAdmin: true,
            key: 'DynamicAnnouncements'
          },
          {
            id: 'announcements-rolling',
            title: '滚动公告',
            type: 'item',
            url: '/panel/announcements/center/rolling/index',
            icon: IconAlarm,
            breadcrumbs: false,
            isAdmin: true,
            key: 'RollingAnnouncements'
          },
          {
            id: 'user-dashboard-card',
            title: '用户总览卡片',
            type: 'item',
            url: '/panel/announcements/center/user/dashboard/card/index',
            icon: IconAlarm,
            breadcrumbs: false,
            isAdmin: true,
            key: 'UserDashboardCard'
          }
        ]
      },
      {
        id: 'modelsquaremanage',
        title: '模型广场',
        type: 'collapse',
        url: '/panel/modelsquaremanage',
        icon: IconBoxModel,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        key: 'ModelSquareManagement',
        children: [
          {
            id: 'modelsquaremanage-card',
            title: '模型卡片',
            type: 'item',
            url: '/panel/modelsquaremanage/card/index',
            icon: IconBoxModel,
            breadcrumbs: false,
            isAdmin: true,
            key: 'ModelSquareManagement'
          },
          {
            id: 'modelsquaremanage-modeltag',
            title: '模型标签',
            type: 'item',
            url: '/panel/modelsquaremanage/modeltag/index',
            icon: IconTag,
            breadcrumbs: false,
            isAdmin: true,
            key: 'ModelLabelManagement'
          }
        ]
      },
      {
        id: 'modelsearch',
        title: '联网搜索',
        type: 'collapse',
        url: '/panel/model/search',
        icon: IconWorldSearch,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        children: [
          {
            id: 'modelsearch-card',
            title: '端点列表',
            type: 'item',
            url: '/panel/model/search/endpoint/index',
            icon: IconBoxModel,
            breadcrumbs: false,
            isAdmin: true,
            key: 'ModelSearchEndpoint'
          }
        ]
      },
      {
        id: 'securityCenter',
        title: '安全中心',
        type: 'collapse',
        icon: IconShieldLock,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        children: [
          {
            id: 'sensitiveWordManage',
            title: '敏感词管理',
            type: 'item',
            url: '/panel/sensitive_word_manage/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'SensitiveWordManage'
          },
          {
            id: 'contentReviewSetting',
            title: '内容审核设置',
            type: 'item',
            url: '/panel/content_review_setting/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ContentReviewSetting'
          },
          {
            id: 'contentReviewUserManage',
            title: '审核用户管理',
            type: 'item',
            url: '/panel/content_review_user_manage/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'ContentReviewUserManage'
          }
        ]
      },
      {
        id: 'authenticationCenter',
        title: '认证中心',
        type: 'collapse',
        icon: IconCertificate,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        children: [
          {
            id: 'personalAuthentication',
            title: '个人认证',
            type: 'item',
            url: '/panel/personal_authentication/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'PersonalAuthentication'
          }
          // {
          //   id: 'enterpriseCertification',
          //   title: '企业认证',
          //   type: 'item',
          //   url: '/panel/enterprise_certification/index',
          //   icon: icons.IconSitemap,
          //   breadcrumbs: false,
          //   isAdmin: false,
          //   key: 'EnterpriseCertification'
          // },
          // {
          //   id: 'enterpriseCertificationAudit',
          //   title: '企业认证审核',
          //   type: 'item',
          //   url: '/panel/auth/enterprise/manage/index',
          //   icon: icons.IconSitemap,
          //   breadcrumbs: false,
          //   isAdmin: false,
          //   group: '运维',
          //   key: 'EnterpriseCertificationAudit'
          // }
        ]
      },
      {
        id: 'enterprisePcenter',
        title: '企业中心',
        type: 'collapse',
        icon: IconCertificate,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        children: [
          {
            id: 'enterpriseAudit',
            title: '企业审核',
            type: 'item',
            url: '/panel/auth/enterprise/manage/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EnterpriseCertificationAudit'
          },
          {
            id: 'enterpriseCertification',
            title: '企业总览',
            type: 'item',
            url: '/panel/enterprise_certification/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EnterpriseCertification'
          },
          {
            id: 'maasVpnChannel',
            title: '算力池-MAAS VPN 端点',
            type: 'item',
            url: '/panel/maas/vpn/channel/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'MaasVpnChannel'
          },
          {
            id: 'orderManagement',
            title: '企业订单信息',
            type: 'item',
            url: '/panel/enterprise_order/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EnterpriseOrder'
          },
          {
            id: 'enterprisePrice',
            title: '价格表-全局价格表',
            type: 'item',
            url: '/panel/enterprise/price/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EnterprisePrice'
          },
          {
            id: 'enterpriseModelPrice',
            title: '价格表-企业定价表',
            type: 'item',
            url: '/panel/enterprise/modelPrice/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'enterpriseModelPrice'
          },
          {
            id: 'enterpriseModelActivity',
            title: '价格表-活动定制',
            type: 'item',
            url: '/panel/enterprise/activity/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'enterpriseModelActivity'
          }
        ]
      },
      {
        id: 'documentCenter',
        title: '文档中心',
        type: 'item',
        url: '/panel/document/center/index',
        icon: IconHelp,
        breadcrumbs: false,
        isAdmin: true,
        group: '运维',
        key: 'DocumentCenter'
      },
      {
        id: 'billingManagement',
        title: '计费管理',
        type: 'collapse',
        icon: IconCoinYen,
        breadcrumbs: false,
        isAdmin: true,
        group: '系统',
        children: [
          {
            id: 'redemption1',
            title: '兑换券',
            type: 'item',
            url: '/panel/redemption/index',
            icon: IconTicket,
            breadcrumbs: false,
            isAdmin: true,
            group: '系统',
            key: 'Exchange'
          },
          {
            id: 'modelrate',
            title: '模型倍率',
            type: 'item',
            url: '/panel/billing/model/rate/index',
            icon: IconTicket,
            breadcrumbs: false,
            isAdmin: true,
            group: '系统',
            key: 'ModelRate'
          },
          {
            id: 'billing-settings',
            title: '计费设置',
            type: 'item',
            url: '/panel/billing/settings/index',
            icon: icons.IconUser,
            breadcrumbs: false,
            isAdmin: true,
            key: 'BillingSettings'
          }
        ]
      },
      {
        id: 'permission',
        title: '权限管理',
        type: 'collapse',
        icon: IconLockSquareRounded,
        breadcrumbs: false,
        isAdmin: true,
        group: '系统',
        key: 'AuthorityManagement',
        children: [
          {
            id: 'role/manage',
            title: '角色管理',
            type: 'item',
            url: '/panel/permission/role/index',
            icon: IconUserEdit,
            breadcrumbs: false,
            isAdmin: true,
            key: 'RoleManagement'
          },
          {
            id: 'point/manage',
            title: '权限点管理',
            type: 'item',
            url: '/panel/permission/point/index',
            icon: IconUserEdit,
            breadcrumbs: false,
            isAdmin: true,
            key: 'AuthorityPointManagement'
          }
        ]
      },
      {
        id: 'equityManagement',
        title: '权益管理',
        type: 'collapse',
        icon: IconRegistered,
        breadcrumbs: false,
        isAdmin: true,
        group: '系统',
        children: [
          {
            id: 'equityList',
            title: '权益列表',
            type: 'item',
            url: '/panel/equity_list/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EquityList'
          },
          {
            id: 'equityPoint',
            title: '权益点',
            type: 'item',
            url: '/panel/equity_point/index',
            icon: icons.IconSitemap,
            breadcrumbs: false,
            isAdmin: false,
            key: 'EquityPoint'
          }
        ]
      },
      {
        id: 'manageuser',
        title: '用户管理',
        type: 'collapse',
        icon: icons.IconUser,
        breadcrumbs: false,
        isAdmin: true,
        group: '系统',
        children: [
          {
            id: 'account',
            title: '用户',
            type: 'item',
            url: '/panel/user/index',
            icon: icons.IconUser,
            breadcrumbs: false,
            isAdmin: true,
            key: 'UserManagement'
          },
          {
            id: 'login-register-setting',
            title: '登录注册设置',
            type: 'item',
            url: '/panel/user/loginorregister/index',
            icon: icons.IconUser,
            breadcrumbs: false,
            isAdmin: true,
            key: 'LoginOrRegisterManagement'
          },
          {
            id: 'consultative-setting',
            title: '协议管理',
            type: 'item',
            url: '/panel/consultative/management/index',
            icon: icons.IconUser,
            breadcrumbs: false,
            isAdmin: true,
            key: 'ConsultativeManagement'
          },
          {
            id: 'authentication-management',
            title: '认证管理',
            type: 'item',
            url: '/panel/authentication/management/index',
            icon: icons.IconUser,
            breadcrumbs: false,
            isAdmin: true,
            key: 'AuthenticationManagement'
          }
        ]
      },

      {
        id: 'setting',
        title: '设置',
        type: 'item',
        url: '/panel/setting/index',
        icon: icons.IconAdjustments,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '系统',
        key: 'Setting'
      },
      {
        id: 'theme/management',
        title: '主题设置',
        type: 'item',
        url: '/panel/system/theme/management/index',
        icon: IconThermometer,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '系统',
        key: 'ThemeManagement'
      },
      {
        id: 'vpn-special-line',
        title: 'VPN专线设置',
        type: 'item',
        url: '/panel/system/vpn/special/line/index',
        icon: IconThermometer,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '系统',
        key: 'VPNSpecialLine'
      },
      {
        id: 'other/management',
        title: '其他管理',
        type: 'item',
        url: '/panel/system/other/management/index',
        icon: IconCircuitResistor,
        breadcrumbs: false,
        isAdmin: true,
        isRoot: true,
        group: '系统',
        key: 'OtherManagement'
      }
    ]
  };
  panel.children = filterMenu(panel.children, permissions);
  return panel;
};

export { getPanel };
